import BaseField from "./BaseField";
import ReCAPTCHA from "react-google-recaptcha";

export class ReCaptchaField extends BaseField{
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        this.props.collectData(this.props.id, value);
    }

    renderRecaptcha(){
        return(
            <ReCAPTCHA
                sitekey={this.props.SiteKey}
                onChange={this.onChange}
                theme={"dark"}
            />
        )
    }

    render() {
        return (
            <div className={this.props.Columns}>
                <div className="field recaptcha">
                    {this.renderRecaptcha()}
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
export default ReCaptchaField;
